module.exports = __webpack_public_path__ + "static/img/jieshu2.f0aad2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/jieshu2.png
// module id = nLAr
// module chunks = 24